import model from './model';

model.routes.setRoutes({
  defaultRoute: {
    enabled: ({ canCreate, canUpdate, canDelete }) => (
      canCreate() || canUpdate() || canDelete()
    ),
  },
});
